import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import classes from "./IDMSupportModalContent.module.css";
import { useSelector, useDispatch } from "react-redux";
import { obtInfoManagementActions } from "Store/obtInfoManagement";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import TextLabel from "components/Common/TextLabel/TextLabel";
import { grey } from "@mui/material/colors";

const IDMSupportModalContent = (props) => {
  const idmDetails = useSelector((state) => state.obtInfoManagement);

  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(props.loading);
  }, [props.loading]);

  const idmSupportList = {
    idmsupport: [
      "Out of Scope",
      "Full Support",
      "Other TTEC Access",
      "Phone IDs Only",
    ],
  };

  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}

      <Grid container rowSpacing={0.5}>
        <Grid item xs={11.5}>
          <TextLabel fontSize={18} text={"IDM support"} subHeading></TextLabel>
        </Grid>
        <Grid item xs={0.5}>
          <CloseIcon
            sx={{ color: grey[500] }}
            onClick={props.onClose}
          ></CloseIcon>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"IDM support"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                size="small"
                disablePortal
                options={idmSupportList.idmsupport}
                value={idmDetails.idmSupport}
                onChange={(event, newValue) => {
                  dispatch(obtInfoManagementActions.setIdmSupport(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search input"
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "#3f5765",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"Primary IDM POC"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                className={classes.textfield}
                placeholder="Input"
                multiline
                rows={1}
                value={idmDetails.primaryIDMPOC}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setPrimaryIDMPOC(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"Backup IDM POC"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.backupIDMPOC}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setBackupIDMPOC(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"IDM Team Lead"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.idmTeamLead}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setIdmTeamLead(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"IDM Team Email"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.idmTeamEmail}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setIdmTeamEmail(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"IDM Owner"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.idmOwner}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setIdmOwner(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"IDM Escalation Point"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.idmEscalationPoint}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setIdmEscalationPoint(
                      e.target.value
                    )
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={"Switch ID POC"}></TextLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                required
                placeholder="Input"
                multiline
                className={classes.textfield}
                rows={1}
                value={idmDetails.switchIDPOC}
                onChange={(e) => {
                  dispatch(
                    obtInfoManagementActions.setSwitchIDPOC(e.target.value)
                  );
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#3f5765",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={8}></Grid>
        <Grid item xs={2}>
          <Button
            sx={{
              textTransform: "none",
              borderRadius: "7px",
              borderColor: "#1a8cff",
            }}
            variant="outlined"
            onClick={props.onClose}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            sx={{
              textTransform: "none",
              borderRadius: "7px",
              backgroundColor: "#3299FF",
            }}
            fullWidth
            variant="contained"
            onClick={props.handleSave}
            disabled={!props.isEdit}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default IDMSupportModalContent;
